import { liveStatsVuexGetters } from '@ahaslides-product/frontend-toolkit'
import { isFeatureEnabled, isPresentationCreatedAfterTurnOnFlag, isPresentationResetAfterTurnOnFlag } from '../featureToggles.module'
import config from '@/config'
import { isClonedFromOnboardingTemplate } from '@/components-v2/onboarding/sampleFeatureBasedOptionsResponse.js'

const _getters = {
  ...liveStatsVuexGetters,

  canUseKvSyncLiveStats: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'kv-sync-emqx-for-live-stats') && isPresentationCreatedAfterTurnOnFlag(rootGetters, 'kv-sync-emqx-for-live-stats')
  },
  isClonedFromTemplateAndNotResetYet: (_, __, rootState) => {
    return isClonedFromOnboardingTemplate(rootState.presentation, rootState.presenterLocale, config.env) && !isPresentationResetAfterTurnOnFlag(rootState.presentation, 'audience-wordcloud-emqx')
  },
  canUseWordCloudEmqx: (_, getters) => {
    if (getters.isClonedFromTemplateAndNotResetYet) {
      return false
    }
    return getters.canUseKvSyncLiveStats
  },
  canUsePollEmqx: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canUseScaleEmqx: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canUseReactionEmqx: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canUseNewChangeSlideMechanism: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-30192-presenter-change-slide')
  },
  canUpdateSlideThroughProxy: (_, __, ___, rootGetters) => {
    if (config.env == 'local') {
      return false
    }
    return isFeatureEnabled(rootGetters, 'presenter-update-slide-through-proxy')
  },
  pollVoteCount: (state, getters, rootState) => {
    if (getters.canUsePollEmqx) {
      return getters.answererCountPerQuestion(rootState.slideActive.id, 0, rootState.slideActive.version)
    }
    return rootState.slideActive.multipleCountAnswer
  },
  scaleVoteCount: (state, getters, rootState) => {
    if (getters.canUseScaleEmqx) {
      return getters.answerCountPerActivity(rootState.slideActive.id, rootState.slideActive.version) / rootState.slideActive.SlideOptions.length
    }
    return rootState.slideActive.multipleCountAnswer
  },
  wordCloudVoteCount: (state, getters, rootState) => {
    if (getters.canUseWordCloudEmqx) {
      return getters.answerCountPerActivity(rootState.slideActive.id, rootState.slideActive.version)
    }
    return rootState.slideActive?.SlideOptions?.length
  },
  canUseWordCloudLiveProxy: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'liveproxy-submit-wordcloud')
  },
}

export default _getters
